
import { TableCell, TableRow } from "@/components/ui/table";
import { LeadAccount } from "@/types/strategy-types";
import LeadAccountActions from "./LeadAccountActions";

interface LeadAccountTableRowProps {
  leadAccount: LeadAccount & { provider_name?: string };
  onEdit: (leadAccount: LeadAccount) => void;
  onDelete: (leadAccount: LeadAccount) => void;
}

const LeadAccountTableRow = ({
  leadAccount,
  onEdit,
  onDelete
}: LeadAccountTableRowProps) => {
  return (
    <TableRow key={leadAccount.id} className={!leadAccount.active ? 'opacity-50' : ''}>
      <TableCell className="font-medium">{leadAccount.external_id}</TableCell>
      <TableCell>{leadAccount.exchange}</TableCell>
      <TableCell>
        {leadAccount.provider_name || 'N/A'}
      </TableCell>
      <TableCell>
        <span className={leadAccount.active ? 'text-green-500' : 'text-red-500'}>
          {leadAccount.active ? 'Active' : 'Inactive'}
        </span>
      </TableCell>
      <TableCell>
        {new Date(leadAccount.created_at || '').toLocaleDateString()}
      </TableCell>
      <TableCell className="text-right">
        <LeadAccountActions
          leadAccount={leadAccount}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      </TableCell>
    </TableRow>
  );
};

export default LeadAccountTableRow;
